import BackToTop from './BackToTop.vue' 

/**
 * Check why can't use () => {}
 */
BackToTop.install = function (Vue, options) {
  Vue.component(BackToTop.name, BackToTop)
}

export default BackToTop



//////////////////
// WEBPACK FOOTER
// ./~/vue-backtotop/src/main.js
// module id = 10
// module chunks = 0